import { useUserAccess } from '@/hooks/useUserAccess';
import { useTranslation } from '@/hooks/useTranslation';
import { useCompanyShareLink } from '@/hooks/useCompanyShareToken';
import { useSnackbar } from '@/features/snackbar';
import ShareIcon from '@simplywallst/ui-core/icons/LinkOutline';
import type { ActionClickProps, Action } from '../types';

export const useShareAction = (): Action => {
  const t = useTranslation();
  const userAccess = useUserAccess();
  const { addSnackbar } = useSnackbar();
  const { createCompanyShareToken } = useCompanyShareLink();

  const handleClick = ({ trackEvent, companyId }: ActionClickProps) => {
    trackEvent({
      type: 'track',
      action: 'click',
      subject: 'share',
    });
    createCompanyShareToken(
      { companyId },
      {
        onSuccess: (data) => {
          const url = new URL(window.location.href);
          url.searchParams.delete('token');
          url.searchParams.append('token', data);
          navigator.clipboard.writeText(url.href).then(
            () => {
              addSnackbar({
                type: 'positive',
                message: 'Share link copied to clipboard',
                lifeTime: 2000,
              });
            },
            // On error accessing clipboard show link in snackbar
            () => {
              addSnackbar({
                type: 'positive',
                message: 'Share link: ' + url.href,
                actionLabel: 'OK',
              });
            }
          );
          trackEvent({
            type: 'track',
            action: 'click',
            subject: 'Create company share link',
          });
        },
      }
    );
  };

  return {
    key: 'share',
    isHidden: userAccess.data.canDistributeCompanyReportPdf !== true,
    smallProps: {
      label: t('page.companyReport.header.actions.copyShare'),
      icon: <ShareIcon />, // TODO: fix icon - too much padding
    },
    handleClick,
  };
};
